import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const ControlledTableSelect = ({ key_name, excel_row, select_status, select_options, on_change_handler, state, label }) => {
  // if(label) {
  //   console.log({label})
  // }
  return (
    <FormControl sx={{
      width: "100%"
    }}>
      <InputLabel
        id={`${key_name}-${excel_row.id}-label`}
      >{label || "Status"}</InputLabel>
      <Select
        MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
        labelId={`${key_name}-${excel_row.id}-label`}
        id={`${key_name}-${excel_row.id}`}
        value={select_status || ""}
        label={label || "Status"}
        onChange={(e) => {
          console.log({ e, value: e.target.value, label, select_status, select_options });
          console.log({ e, state, excel_row, id: excel_row.order, key_name, value: e.target.value });
          on_change_handler(e, state, excel_row, excel_row.order, key_name);
        }}
      // onChange={(e) => {
      //   // set_select_status(e.target.value);
      //   // dispatch(handle_backlog_remarks_update(backlog, e, excel_row, excel_row.id, key_name));
      //   // on_change_handler(e, state, excel_row, excel_row.id, key_name);
      //   console.log({ e });
      // }}
      >
        {
          select_options.map(({ value, label }, index) =>
            <MenuItem
              sx={{
                textOverflow: "ellipsis"
              }}
              key={`${excel_row.id}-${value}-${label}-${key_name}-${index}`}
              value={value}
            >{label}</MenuItem>
          )
        }
      </Select>
    </FormControl>
  );
};

export default ControlledTableSelect;